import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import { UnauthorizedLayoutTemplate } from 'APP/components/UnauthorizedLayoutTemplate/UnauthorizedLayoutTemplate';

import { LoginRegionSupportInfo } from '../../../components/LoginRegionSupportInfo/LoginRegionSupportInfo';
import { DiscoverDestinationSelectorForm } from '../../../components/RegionSelectorForm/DiscoverDestinationSelectorForm';
import {
  ILoginServerSelectStepProps,
  useLoginServerSelectStepPresenter,
} from './LoginServerSelectStep.presenter';
import styles from './LoginServerSelectStep.styles.m.css';

export const LoginServerSelectStep: FC<ILoginServerSelectStepProps> = observer((props) => {
  const presenter = useLoginServerSelectStepPresenter(props);
  const { t } = useTranslation();
  const { loginPresenter } = props;

  return (
    <UnauthorizedLayoutTemplate
      onBack={presenter.onBackHandler || undefined}
      title={t('auth_server_select_title')}
      subtitle={t('auth_server_select_description')}
      info={<LoginRegionSupportInfo />}
      message={loginPresenter.errorMessage}
    >
      {presenter.serversDestinations.length && (
        <div className={styles.content}>
          <DiscoverDestinationSelectorForm
            destinations={presenter.serversDestinations}
            onSubmit={presenter.onSubmit}
          />

          <div className={styles.newServerTitle}>{t('auth_server_select_not_found')}</div>
          <Button
            onClick={presenter.onAddNewServer}
            theme="16"
            size="20"
          >
            {t('auth_server_add_new')}
          </Button>
        </div>
      )}
    </UnauthorizedLayoutTemplate>
  );
});
